module.exports = __webpack_public_path__ + "static/img/antenatal3.3aca47c4.jpg";